/* Built In Imports */
import React from 'react';
/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { nanoid } from 'nanoid';
/* Internal Imports */
/* Components */
import Post from '@lb/components/Blogs/Post';
/* Styles */
/* Services */

const BlogsSection = ({ blogs }) => {
  return (
    <>
      <Box maxW={1330} mx="auto" w="100%">
        <Box pos="relative" pt="60px" pb="20px">
          <Box
            position="absolute"
            top="0"
            left={0}
            right={0}
            height="100%"
            background="linear-gradient(180deg, #D4C3A2 0%, rgba(217, 217, 217, 0) 60.56%)"
            zIndex={0}
          ></Box>
          <Flex
            gridGap={{ base: '20px', md: '30px' }}
            flexWrap="wrap"
            flexDir="row"
            w="auto"
            mx="auto"
            maxW={1210}
            alignItems="flex-start"
            justifyContent={{
              base: 'center',
              md: 'center',
              lg: 'center',
              xl: 'flex-start',
            }}
            _after={{
              content: "''",
              width: '100%',
              maxW: '378px',
              minW: '280px',
            }}
          >
            {blogs?.map(blog => (
              <>
                <Post post={blog} key={nanoid()} />
              </>
            ))}
          </Flex>
        </Box>
      </Box>
    </>
  );
};

export default BlogsSection;
